import newsletterTypes from "./newsletter.types";

export const signUpNewsletterStart = (email) => ({
  type: newsletterTypes.SIGN_UP_NEWSLETTER_START,
  payload: email,
});
